export default __webpack_public_path__ + "static/asset-b46b3e2b7764aa56264652ad40e3c03a.webp";